module.exports = __webpack_public_path__ + "img/015.f899611c.png";